// Pure helpers for the spreadsheet grid: ranges, clipboard TSV, fill-series, value coercion.
export const normRange = (a, b) => ({
  r0: Math.min(a.r, b.r), r1: Math.max(a.r, b.r), c0: Math.min(a.c, b.c), c1: Math.max(a.c, b.c),
});

export const inRange = (rg, r, c) => rg && r >= rg.r0 && r <= rg.r1 && c >= rg.c0 && c <= rg.c1;

export const cellText = (col, row) => {
  if (col.type === "computed") return col.display ? col.display(row) : "";
  const v = row[col.key];
  if (col.type === "select") {
    const options = col.optionsFor ? col.optionsFor(row) : col.options;
    const o = options.find(x => String(x.value) === String(v));
    if (o) return o.label;
    return col.display ? col.display(row) : (v ?? "");
  }
  return v === null || v === undefined ? "" : String(v);
};

// Coerce pasted / typed text into a storable value for the column. Returns undefined when invalid.
export const coerce = (col, text, row) => {
  const t = String(text ?? "").trim();
  if (col.type === "number") { if (t === "") return 0; const n = Number(t); return isNaN(n) ? undefined : n; }
  if (col.type === "select") {
    if (t === "") return null;
    const options = col.optionsFor && row ? col.optionsFor(row) : col.options;
    const o = options.find(x => String(x.value).toLowerCase() === t.toLowerCase() || x.label.toLowerCase() === t.toLowerCase()
      || x.label.toLowerCase().startsWith(t.toLowerCase()));
    return o ? o.value : undefined;
  }
  return t;
};

export const toTSV = (rows, cols, rg) => {
  const lines = [];
  for (let r = rg.r0; r <= rg.r1; r++) {
    const cells = [];
    for (let c = rg.c0; c <= rg.c1; c++) cells.push(cellText(cols[c], rows[r]));
    lines.push(cells.join("\t"));
  }
  return lines.join("\n");
};

export const parseTSV = (text) => {
  const lines = String(text || "").replace(/\r\n?/g, "\n").split("\n");
  if (lines.length > 1 && lines[lines.length - 1] === "") lines.pop();
  return lines.map(l => l.split("\t"));
};

// Excel-style fill: numeric source of >=2 values extends linearly; otherwise the pattern repeats.
export const fillValues = (source, count) => {
  if (!source.length) return [];
  const nums = source.map(v => (typeof v === "number" ? v : Number(v)));
  const numeric = source.length >= 2 && source.every(v => v !== "" && v !== null) && nums.every(n => !isNaN(n));
  const out = [];
  if (numeric) {
    const step = nums[nums.length - 1] - nums[nums.length - 2];
    for (let i = 1; i <= count; i++) out.push(nums[nums.length - 1] + step * i);
  } else {
    for (let i = 0; i < count; i++) out.push(source[i % source.length]);
  }
  return out;
};
